type Listener = () => void;

let backendSessionReady = true;
const listeners = new Set<Listener>();

export const markBackendSessionPending = () => {
  // Mark backend session as not yet ready after login starts.
  backendSessionReady = false;
};

export const markBackendSessionReady = () => {
  // Resolve all waiters once the backend session cookie is established.
  if (backendSessionReady) {
    return;
  }
  backendSessionReady = true;
  listeners.forEach((listener) => listener());
  listeners.clear();
};

export const isBackendSessionReady = () => backendSessionReady;

export const waitForBackendSessionReady = () =>
  // Resolve immediately if ready, otherwise wait for the ready signal.
  backendSessionReady ? Promise.resolve() : new Promise<void>((resolve) => listeners.add(resolve));
